import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { getStoresBySellerIdRequest } from '../../api/Actor/getStoresBySellerIdQuery';
import { getStoresRequest } from '../../api/Actor/getStoresQuery';
import { executeSagaRequest } from '../../services';

import { GetStoresBySellerIdPayload, GetStoresPayload } from './actionCreators';
import * as types from './actionTypes';
import {
  selectGetStoreBySellerIdIsLoading,
  selectGetStoreBySellerIdWasLoaded,
  selectGetStoreIsLoading,
  selectGetStoreWasLoaded,
} from './selectors';

function* getStoreWorker({
  payload,
}: {
  payload: GetStoresPayload;
}): Generator {
  const { storeId = null } = payload;

  if (!storeId) {
    return;
  }

  const isLoading = yield select(selectGetStoreIsLoading, {
    storeId,
  });
  const wasLoaded = yield select(selectGetStoreWasLoaded, { storeId });

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_STORE,
    getStoresRequest({ storeId }),
    { indexer: storeId },
  );

  yield put(types.GET_STORE.end({ storeId }));
}
function* getStoreWatcher() {
  yield takeEvery<Action<GetStoresPayload>>(
    types.GET_STORE.BASE,
    getStoreWorker,
  );
}

function* getStoresBySellerIdWorker({
  payload,
}: {
  payload: GetStoresBySellerIdPayload;
}): Generator {
  const { sellerId = null } = payload;

  if (!sellerId) {
    return;
  }

  const isLoading = yield select(selectGetStoreBySellerIdIsLoading, {
    sellerId,
  });
  const wasLoaded = yield select(selectGetStoreBySellerIdWasLoaded, {
    sellerId,
  });

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_STORES_BY_SELLER_ID,
    getStoresBySellerIdRequest({ sellerId }),
    {
      sellerId,
      indexer: sellerId,
    },
  );

  yield put(types.GET_STORES_BY_SELLER_ID.end({ sellerId }));
}
function* getStoresBySellerIdWatcher() {
  yield takeEvery<Action<GetStoresBySellerIdPayload>>(
    types.GET_STORES_BY_SELLER_ID.BASE,
    getStoresBySellerIdWorker,
  );
}

export default function* storeSaga(): Generator {
  try {
    yield all([getStoreWatcher(), getStoresBySellerIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
